import { render, staticRenderFns } from "./content-list-filter-app.vue?vue&type=template&id=1219e03a&"
import script from "./content-list-filter-app.vue?vue&type=script&lang=js&"
export * from "./content-list-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports